export const MODAL_TITLE = "Wheel of Life";

export const SAVE_BTN_TEXT = "Save";

export const CANCEL_BTN_TEXT = "Cancel";

export const MODAL_WIDTH = "75%";

export const TOGGLE_LABEL = "Show wheel of life on the dashboard";

export const ERROR_MESSAGES = {
  SELECT_DATE: "Please select a date",
  SAVE_FAILED: "Failed to save the data",
};

export const ALL_VALUES_ZERO_COUNT = 10;
